import React, { Component } from "react";

class VerifyEmailWarning extends Component {
  render() {
    return (
      <div>
        <span>Your Email is Unverified:</span>
        <button
          onClick={() => {
            this.props.sendVerificationEmail(this.props.user);
          }}
          className="bold btn btn-link">
          Send Verification Email
        </button>
      </div>
    );
  }
}

export default VerifyEmailWarning;
